import React, { Component } from 'react'
import PropTypes from 'prop-types'

import { Container, Row, Col, Card, Button } from 'react-bootstrap'

import { FreeMode, Pagination } from 'swiper/modules'
import { Swiper, SwiperSlide } from 'swiper/react'

import 'swiper/css'
import 'swiper/css/pagination'
import './../pagination_fix.sass'

import styles from './../blocks.module.sass'

export default class Main extends Component {

  render() {

    const { ajax_data, page_data, hideMore } = this.props

    return (
      <div className={styles.shopsng}>
        <Container>
          <div className={styles.shopsng_top + ` w-100 d-flex justify-content-between align-items-center`}>
            <div className={styles.shopsng_title}>МАГАЗИНЫ</div>
            <div className="d-none d-lg-flex justify-content-start align-items-center">
              <div>
                <div className={styles.shopsng_svaztitle}>Связаться с нами</div>
                {page_data.phone &&
                  <a href={`tel:` + page_data.phone.replace(/[-()\s]/g, '')} className={styles.shopsng_svazphone}>{page_data.phone}</a>
                }
              </div>
              {page_data.tg &&
                <a className={styles.shopsng_svazicon} href={page_data.tg}>
                  <svg width="16" height="15" viewBox="0 0 16 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M1.05925 6.76887C1.05925 6.76887 7.74253 3.8049 10.0604 2.76122C10.949 2.34378 13.9622 1.00786 13.9622 1.00786C13.9622 1.00786 15.353 0.423446 15.2371 1.8428C15.1984 2.42727 14.8894 4.47281 14.5803 6.68538C14.1167 9.81637 13.6145 13.2395 13.6145 13.2395C13.6145 13.2395 13.5373 14.1997 12.8805 14.3667C12.2238 14.5337 11.1421 13.7823 10.949 13.6153C10.7944 13.4901 8.05157 11.6115 7.04715 10.693C6.77672 10.4426 6.46768 9.94164 7.08575 9.35716C8.47652 7.97953 10.1377 6.26794 11.1421 5.18254C11.6057 4.68156 12.0692 3.51267 10.1377 4.93202C7.39484 6.97762 4.69062 8.89795 4.69062 8.89795C4.69062 8.89795 4.0725 9.31539 2.91357 8.93966C1.75458 8.564 0.402469 8.06301 0.402469 8.06301C0.402469 8.06301 -0.524636 7.43683 1.05925 6.76887Z" fill="white"/>
                  </svg>
                </a>
              }
            </div>
          </div>
          {ajax_data != null &&
            <>
              {'shops_ng' in ajax_data &&
                <Row className='d-none d-lg-flex'>
                  {ajax_data.shops_ng.map((elm, i) => {
                    return (
                      <Col key={i} lg={6}>
                        <Card className={styles.shopsng_card}>
                          <Card.Img className={styles.shopsng_card_img} src={elm.photo} width={657} height={361} alt={elm.name} />
                          <Card.ImgOverlay className={styles.shopsng_card_body}>
                            <div className='w-100 d-flex align-items-end justify-content-between'>
                              <div>
                                <div className={styles.shopsng_card_title}>{elm.name}</div>
                                {elm.worktime &&
                                  <div className={styles.shopsng_card_adres + ` mb-2`}>Время работы: {elm.worktime}</div>
                                }
                                <div className={styles.shopsng_card_adres}>{elm.adres}</div>
                              </div>
                              <div className={styles.shopsng_card_btns}>
                                {!hideMore &&
                                  <>
                                    {elm.link &&
                                      <Button href={elm.link} variant="outline-light">Подробнее</Button>
                                    }
                                  </>
                                }
                                {elm.marshrut &&
                                  <Button href={elm.marshrut} target="_blank" variant="light">Маршрут</Button>
                                }
                              </div>
                            </div>
                          </Card.ImgOverlay>
                        </Card>
                      </Col>
                    )
                  })}
                </Row>
              }
              {'shops_ng' in ajax_data &&
                <Swiper
                  modules={[FreeMode, Pagination]}
                  pagination={{ type: `progressbar` }}
                  spaceBetween={6}
                  slidesPerView={`auto`}
                  freeMode={true}
                  className={styles.shopsng_slyder + ` d-lg-none`}
                  speed={300}
                >
                  {ajax_data.shops_ng.map((elm, i) => {
                    return (
                      <SwiperSlide key={i} className={styles.shopsng_card_w}>
                        <Card className={styles.shopsng_card}>
                        <Card.Img className={styles.shopsng_card_img} src={elm.photo_mob} width={299} height={343} alt={elm.name} />
                          <Card.ImgOverlay className={styles.shopsng_card_body}>
                            <div className='w-100 d-flex flex-column flex-lg-row align-items-center align-items-lg-end justify-content-between'>
                              <div>
                                <div className={styles.shopsng_card_title}>{elm.name}</div>
                                {elm.worktime &&
                                  <div className={styles.shopsng_card_adres + ` mb-2`}>Время работы: {elm.worktime}</div>
                                }
                                <div className={styles.shopsng_card_adres}>{elm.adres}</div>
                              </div>
                              <div className={styles.shopsng_card_btns}>
                                {!hideMore &&
                                  <>
                                    {elm.link &&
                                      <Button href={elm.link} variant="outline-light">Подробнее</Button>
                                    }
                                  </>
                                }
                                {elm.marshrut &&
                                  <Button href={elm.marshrut} target="_blank" variant="light">Маршрут</Button>
                                }
                              </div>
                            </div>
                          </Card.ImgOverlay>
                        </Card>
                      </SwiperSlide>
                    )
                  })}
                  <SwiperSlide className={styles.shopsng_card_w_last}></SwiperSlide>
                </Swiper>
              }
            </>
          }
          <div className="w-100 d-flex d-lg-none justify-content-between align-items-center">
            <div>
              <div className={styles.shopsng_svaztitle}>Связаться с нами</div>
              {page_data.phone &&
                <a href={`tel:` + page_data.phone.replace(/[-()\s]/g, '')} className={styles.shopsng_svazphone}>{page_data.phone}</a>
              }
            </div>
            {page_data.tg &&
              <a className={styles.shopsng_svazicon} href={page_data.tg}>
                <svg width="16" height="15" viewBox="0 0 16 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M1.05925 6.76887C1.05925 6.76887 7.74253 3.8049 10.0604 2.76122C10.949 2.34378 13.9622 1.00786 13.9622 1.00786C13.9622 1.00786 15.353 0.423446 15.2371 1.8428C15.1984 2.42727 14.8894 4.47281 14.5803 6.68538C14.1167 9.81637 13.6145 13.2395 13.6145 13.2395C13.6145 13.2395 13.5373 14.1997 12.8805 14.3667C12.2238 14.5337 11.1421 13.7823 10.949 13.6153C10.7944 13.4901 8.05157 11.6115 7.04715 10.693C6.77672 10.4426 6.46768 9.94164 7.08575 9.35716C8.47652 7.97953 10.1377 6.26794 11.1421 5.18254C11.6057 4.68156 12.0692 3.51267 10.1377 4.93202C7.39484 6.97762 4.69062 8.89795 4.69062 8.89795C4.69062 8.89795 4.0725 9.31539 2.91357 8.93966C1.75458 8.564 0.402469 8.06301 0.402469 8.06301C0.402469 8.06301 -0.524636 7.43683 1.05925 6.76887Z" fill="white"/>
                </svg>
              </a>
            }
          </div>
        </Container>
      </div>
    )
  }
}

Main.propTypes = {
  ajax_data: PropTypes.object,
  page_data: PropTypes.object,
  hideMore: PropTypes.bool
}